// extracted by mini-css-extract-plugin
export default {"breadcrumbs-text":"Breadcrumbs_breadcrumbs-text__Ixaaz"};